import React from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import TableLoadingState from '../../components/common/TableLoadingState'
import TablePager from '../../components/common/TablePager'
import {
  listPageDataGridSx,
  listPageGridSlots,
} from '../../components/common/ListPageShell'
import { useClientPagination } from '../../hooks/useClientPagination'
import '../../components/common/ListPageTable.css'

type MappingPaginatedGridProps = {
  rows: any[]
  columns: GridColDef[]
  getRowId: (row: any) => string
  loading?: boolean
  pageSize?: number
}

/** DataGrid styled like list-page tables, with client-side TablePager. */
export default function MappingPaginatedGrid({
  rows,
  columns,
  getRowId,
  loading = false,
  pageSize = 10,
}: MappingPaginatedGridProps) {
  const pager = useClientPagination(rows, pageSize)

  if (loading) {
    return (
      <div className="incyia-table-wrap mapping-flow-grid-wrap">
        <TableLoadingState compact />
      </div>
    )
  }

  return (
    <div className="incyia-table-wrap mapping-flow-grid-wrap">
      <DataGrid
        loading={false}
        rows={pager.pageItems}
        columns={columns}
        hideFooterPagination
        hideFooter
        disableColumnMenu
        disableColumnSelector
        disableRowSelectionOnClick
        getRowId={getRowId}
        getRowHeight={() => 56}
        slots={listPageGridSlots}
        sx={listPageDataGridSx(pager.pageItems.length)}
      />
      {pager.showPager ? (
        <TablePager
          page={pager.page}
          pageSize={pager.pageSize}
          total={pager.total}
          pageCount={pager.pageCount}
          from={pager.from}
          to={pager.to}
          pageSizeOptions={pager.pageSizeOptions}
          onPageChange={pager.setPage}
          onPageSizeChange={pager.setPageSize}
        />
      ) : null}
    </div>
  )
}
